import { defineAction } from '~/prix'
import { z } from 'zod'
import roadMaintenanceDeleteAction from './roadMaintenanceDelete.action.json' with { type: 'json' }
import { roadMaintenanceObject } from '../roadMaintenanceObject'

const roadMaintenanceDeleteDefinition = defineAction({
  ...roadMaintenanceDeleteAction,

  input: z.object({ id: roadMaintenanceObject.shape.id }),
  output: z.object({}),
})

export default roadMaintenanceDeleteDefinition
